import { useEffect, useMemo, useState } from "react";
import { fetchInjuryNews, fetchFPLData } from "../api/fplApi";

const InjuryNews = ({ compact = false }) => {
  const [news, setNews] = useState([]);
  const [teams, setTeams] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const perPage = compact ? 4 : 12;

  useEffect(() => {
    Promise.all([fetchInjuryNews(), fetchFPLData()])
      .then(([injuries, bootstrap]) => {
        setNews(injuries || []);
        setTeams(bootstrap?.teams || []);
      })
      .catch(() => setNews([]))
      .finally(() => setLoading(false));
  }, []);

  const teamMap = useMemo(() => Object.fromEntries(teams.map((t) => [t.id, t])), [teams]);
  const totalPages = Math.max(1, Math.ceil(news.length / perPage));
  const rows = news.slice(page * perPage, page * perPage + perPage);

  if (loading) return <div className="fpl-empty">Loading availability news…</div>;
  if (!news.length) return <div className="fpl-empty">No injury or suspension updates available.</div>;

  if (compact) {
    return (
      <div>
        <div className="fpl-news-compact">
          {rows.map((p) => (
            <div className="fpl-news-card" key={p.id}>
              <img src={`https://fantasy.premierleague.com/dist/img/shirts/standard/shirt_${p.team_code}-220.webp`} alt="" />
              <div className="min-w-0">
                <div className="font-extrabold text-slate-900 truncate">{p.web_name}</div>
                <p className="text-xs text-slate-500 mt-1 line-clamp-2">{p.news || "No update available"}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="fpl-availability-page">
      <div className="fpl-page-intro-card">
        <div>
          <span className="fpl-eyebrow">PLAYER AVAILABILITY</span>
          <h2>Injuries & Suspensions</h2>
          <p>Official FPL availability notes, status and return information.</p>
        </div>
        <strong>{news.length} updates</strong>
      </div>

      <div className="fpl-injury-list">
        {rows.map((p) => {
          const team = teamMap[p.team];
          const chance = p.chance_of_playing_next_round;
          return (
            <article className="fpl-injury-row" key={p.id}>
              <div className="fpl-injury-kit">
                <img src={`https://fantasy.premierleague.com/dist/img/shirts/standard/shirt_${p.team_code}-220.webp`} alt="" />
              </div>
              <div className="fpl-injury-player">
                <strong>{p.web_name}</strong>
                <span>{team?.name || "Premier League"} · {p.element_type === 1 ? "GK" : p.element_type === 2 ? "DEF" : p.element_type === 3 ? "MID" : "FWD"}</span>
              </div>
              <div className="fpl-injury-news">
                <span className="fpl-injury-status">{p.status === "s" ? "Suspended" : p.status === "i" ? "Injured" : p.status === "d" ? "Doubtful" : "Unavailable"}</span>
                <p>{p.news || "No update available"}</p>
              </div>
              <div className="fpl-injury-chance">
                <small>Chance of playing</small>
                <strong>{chance == null ? "—" : `${chance}%`}</strong>
              </div>
            </article>
          );
        })}
      </div>

      {totalPages > 1 && (
        <div className="fpl-pagination mt-5">
          <button disabled={page === 0} onClick={() => setPage((x) => x - 1)}>Previous</button>
          <span>Page {page + 1} of {totalPages}</span>
          <button disabled={page + 1 >= totalPages} onClick={() => setPage((x) => x + 1)}>Next</button>
        </div>
      )}
    </div>
  );
};
export default InjuryNews;
